/** Only explicit synonyms: never collapse central defenders or numbered line slots. */
const equivalentKeys: Record<string, string> = {
  rightdefense: 'rightBack',
  rightback: 'rightBack',
  leftdefense: 'leftBack',
  leftback: 'leftBack',
};

export const canonicalPositionKey = (key: string): string =>
  equivalentKeys[key.toLowerCase()] ?? key;

export const positionsEquivalent = (left: string, right: string): boolean =>
  canonicalPositionKey(left) === canonicalPositionKey(right);

/** Preserve the actual formation key; exact matches take precedence over aliases. */
export const resolvePositionKey = (key: string, available: Iterable<string>): string | undefined => {
  const keys = Array.from(available);
  return keys.includes(key) ? key : keys.find(candidate => positionsEquivalent(key, candidate));
};
